import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { AccountCreateDialog } from 'account/dialogs/account-create.dialog';

import * as ACCOUNT_ACTIONS from './account-actions';

@Injectable()
export class AccountEffects {

  /**
   * Watches for a change in the router campaignId
   * and updates the current campaign context
   * with the campaign object from graphql
   */
  openCreateAccountDialog$ = createEffect(
    () => this.actions$.pipe(
      ofType(ACCOUNT_ACTIONS.OPEN_CREATE_ACCOUNT_DIALOG),
      tap(({payload}) => {
        this.dialog.open<AccountCreateDialog>(AccountCreateDialog, {
          data: {
            initialValues: payload
          }
        });
      })
    ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private dialog: MatDialog
  ) {
  }
}
